import React, { Component } from "react";
import PageTeamMember from './PageTeamMember';

export default class PageTeam extends Component {
	  	
	render () {
		
		let block = this.props.block;
										
	    return (
		    
			<div id={block.id} className={'c-page__block c-page__block--max-width c-page__block--space-' + block.space + ' c-page__block--load-effect'}>
		     
				<div className="l-grid">
			    
			    	<div className="l-grid__col">
			    	
			    		<div className="c-team">
			    			
			    			{block.team.map((member,i) =>
								{
									return (
										<PageTeamMember item={member} key={i}></PageTeamMember>
									)
								}
							)}
						    				    
					    </div>
					    
					</div>
					
				</div>
				
		    </div>
		)
	}
}
